import Constants from '../actions/types';
import { removeMilliseconds } from '../utils';

const initialState = {
  customFields: [],
  loading: false,
  message: null,
  severity: null,
  selected: null,
  customFieldNames: []
};

const customFieldsReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.CUSTOMFIELDS_GET_REQUEST: {
      const newState = {
        ...state,
        loading: true
      };

      return newState;
    }

    case Constants.CUSTOMFIELDS_GET_SUCCESS: {
      const data = action.payload.map(value => removeMilliseconds(value));
      const customFieldNames = action.payload.map(field => field.fieldName);
      const newState = {
        ...state,
        customFields: data,
        selected: data ? data[0] : null,
        loading: false,
        customFieldNames
      };

      return newState;
    }

    case Constants.CUSTOMFIELDS_GET_FAILURE: {
      const newState = {
        ...state,
        customFields: [],
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.CUSTOMFIELDS_SAVE_REQUEST: {
      const newState = {
        ...state,
        loading: true
      };

      return newState;
    }

    case Constants.CUSTOMFIELDS_ADD_SUCCESS: {
      const newCustomFields = [...state.customFields, action.payload];
      const newState = {
        ...state,
        customFields: newCustomFields,
        loading: false,
        message: `Added custom field ${action.payload.fieldName} successfully.`,
        severity: 'info'
      };

      return newState;
    }

    case Constants.CUSTOMFIELDS_SAVE_SUCCESS: {
      const selectedField = state.customFields.find(
        field => field.fieldName === action.payload.fieldName
      );
      const index = state.customFields.indexOf(selectedField);
      const newCustomFields = [].concat(
        state.customFields.slice(0, index),
        action.payload,
        state.customFields.slice(index + 1)
      );
      const newState = {
        ...state,
        customFields: newCustomFields,
        loading: false,
        message: `Saved custom field ${selectedField.fieldName} successfully.`,
        severity: 'info'
      };

      return newState;
    }

    case Constants.CUSTOMFIELDS_DELETE_SUCCESS: {
      const selectedField = state.customFields.find(
        field => field.fieldName === action.payload.fieldName
      );
      const index = state.customFields.indexOf(selectedField);
      const newCustomFields = [].concat(
        state.customFields.slice(0, index),
        state.customFields.slice(index + 1)
      );
      const newState = {
        ...state,
        customFields: newCustomFields,
        loading: false,
        message: `Deleted custom field ${selectedField.fieldName} successfully.`,
        severity: 'info'
      };

      return newState;
    }

    case Constants.CUSTOMFIELDS_SAVE_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.CUSTOMFIELDS_GENERATE_SUCCESS: {
      const newState = {
        ...state,
        message: `Initiated the job to regenerate custom fields successfully.`,
        severity: 'info'
      };

      return newState;
    }

    case Constants.CUSTOMFIELDS_GENERATE_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error'
      };

      return newState;
    }

    case Constants.CUSTOMFIELDS_REPLACE_SUCCESS: {
      const newCustomFields = action.payload;
      const newState = {
        ...state,
        customFields: newCustomFields,
        loading: false,
        message: 'Replaced the custom field configuration successfully.',
        severity: 'info'
      };

      return newState;
    }

    case Constants.CUSTOMFIELDS_REPLACE_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error'
      };

      return newState;
    }

    case Constants.CUSTOMFIELDS_CLEAR_ERROR: {
      const newState = {
        ...state,
        message: null,
        severity: null
      };

      return newState;
    }

    default: {
      return state;
    }
  }
};

export default customFieldsReducer;
